import {
  AlertsUserAction,
  AlertsUserActionTypes,
  AlertsUserState,
} from './alertsUserTypes'

const initialState: AlertsUserState = {
  alertsUser: [],
  isLoading: true,
}

export default function alertsUserReducer(
  state = initialState,
  action: AlertsUserAction
) {
  switch (action.type) {
    // get item
    case AlertsUserActionTypes.GET_ALERTS_USER_START:
      return {
        ...state,
        isLoading: true,
      }

    case AlertsUserActionTypes.GET_ALERTS_USER_SUCCESS:
      if (!action.alertsUser) {
        throw new Error()
      }
      return {
        ...state,
        isLoading: false,
        alertsUser: action.alertsUser,
      }

    case AlertsUserActionTypes.GET_ALERTS_USER_ERROR:
      return {
        ...state,
        isLoading: false,
      }

    default:
      return state
  }
}
